import * as actionTypes from '../consts/actionTypes';

export function getHeadquaters() {
    return {
        type: actionTypes.GET_ALL_HEADQUATERS,
        payload: ''
    };
}